/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { InstantAnswerPerson } from './InstantAnswerPerson';

export type InstantAnswer = {
    kind: InstantAnswer.kind;
    title: string;
    excerpt?: (string | null);
    source: string;
    url?: (string | null);
    updated_on?: (string | null);
    people?: Array<InstantAnswerPerson>;
    article_id?: (string | null);
};

export namespace InstantAnswer {

    export enum kind {
        KNOWLEDGE = 'knowledge',
        MANAGER = 'manager',
        OWNER = 'owner',
    }


}

